function qs(selector) {
    return selector instanceof HTMLElement ? selector : document.querySelector(selector);
}
export default qs;
